import { makeAutoObservable } from 'mobx';
import { AntavoImage } from './shared/Image';

type ChallengeProgressCriteria = {
  action: string;
  message: string;
  threshold: number;
  current: number;
  is_completed: boolean;
}

type ChallengeProgress = {
  overall: number;
  criteria: ChallengeProgressCriteria[];
}

export interface Challenge {
  id: string;
  title: string;
  description: string;
  image: AntavoImage;
  points: number;
  progress: ChallengeProgress;
  url: string;
  cta_label: string;
  completions: number;
  ends_at: string;
  starts_at: string;
}

class ChallengesStore {
  challenges: Challenge[] = [];
  isLoading: boolean = false;
  rewardApiUrl?: string = process.env.REACT_APP_REWARD_API_URL;
  customerUrl?: string = process.env.REACT_APP_CUSTOMER_API_URL;

  constructor() {
    makeAutoObservable(this);
  }

  async getChallenges(customerId: string) {
    this.isLoading = true;
    if (!this.rewardApiUrl) {
      console.error('process.env.REACT_APP_REWARD_API_URL is not defined and it is needed by the challenge store');
      return;
    }
    const res = await fetch(`${this.rewardApiUrl}/${customerId}/challenges`,  { headers: { 'Accept-Language': 'en' }});
    const json = await res.json();
    if (json.data) {
      this.challenges = json.data;
    }
    this.isLoading = false;
    return this.challenges;
  }
  async getAllEntityChallenges() {
    this.isLoading = true;
    const res = await fetch(
      'https://api.salesdemo.antavo.com/entities/challenges/challenge?api_key=AN2OF2LPTAAFGDVOCOH',
      { headers: { 'Accept-Language': 'en' }}
    )
    if (res.ok) {
      const json = await res.json();
      return json.data
    }
  }

  async watchVideo(customerId: string, url: string, acceptLang?: string) {
    this.isLoading = true;
    if (!this.customerUrl) {
      console.error('process.env.REACT_APP_AUTH_API_URL is not defined and it is needed by the auth store');
      return;
    }
    const res = await fetch(
      `${this.customerUrl}customer/event`,
      {
        headers: {
          'Accept-Language': acceptLang ? acceptLang : 'en'
        },
        method: 'POST',
        body: JSON.stringify({
          customer: customerId,
          action: 'video',
          data: {
            url
          }
        })
      }
    );
    const json = await res.json();
    this.isLoading = false;
    return json;
  }

}

export const challengesStore = new ChallengesStore();